import { GlobalSettings } from '@ppg/shared/feature-flag';

export function getContextClientName(globalSettings: GlobalSettings | undefined) {
  return globalSettings?.anonymousJourneyEnabled ? { context: { clientName: 'hybrid' } } : undefined;
}

export function getContextClientNameIfAnonymousTransactable(
  globalSettings: GlobalSettings | undefined,
  isProductDetailsAnonymous: boolean,
) {
  return globalSettings?.anonymousJourneyEnabled && isProductDetailsAnonymous
    ? { context: { clientName: 'hybrid' } }
    : undefined;
}
